import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useForm } from 'react-hook-form';
import { Grid } from '@mui/material';
import { dropBoolean } from 'utils/drops';
import { GridContext } from 'contexts/GridContext';
import { DropsContext } from 'contexts/DropsContext';
import Container from 'components/Container';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import Header from 'components/Header';
import Input from 'components/Input';
import Card from 'components/Card';

const Manutenção = () => {
  const rotina = 'Cidade';
  const defaultValues = {
    localidade: '',
    uf_id: null,
    cepbase: '',
    codigo_ibge: '',
    livrecom: null,
    codmunicipio: '',
  };
  const navigate = useNavigate();
  const { state } = useLocation();
  const { drops, getDrops } = useContext(DropsContext);
  const { postLoading, postGrid } = useContext(GridContext);
  const { control, handleSubmit, reset } = useForm({ defaultValues });

  useEffect(() => {
    reset(state?.values);
  }, []);

  const onSubmit = (data) =>
    postGrid({
      data: { data, rotina },
      cb: () => {
        navigate(-1);
        getDrops([rotina]);
      },
    });

  return (
    <Container>
      <Header titulo={(Boolean(state) ? 'Editar' : 'Cadastrar') + ' Cidade'} />
      <Card>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Input name="localidade" control={control} label="Localidade" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Dropdown
              name="uf_id"
              control={control}
              label="Sigla"
              options={drops?.UF}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Input name="cepbase" control={control} label="CEP Base" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Dropdown
              name="livrecom"
              control={control}
              label="Livre Comércio"
              options={dropBoolean}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Input
              name="codigo_ibge"
              control={control}
              label="Código IBGE"
              type="number"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Input
              name="codmunicipio"
              control={control}
              label="Código do Município"
              type="number"
            />
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit(onSubmit)}
              loading={postLoading}
            >
              Salvar
            </Button>
          </Grid>
        </Grid>
      </Card>
    </Container>
  );
};

export default Manutenção;
